module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@nodeject/wbs","commonjs2":"@nodeject/wbs","commonjs":"@nodeject/wbs","amd":"@nodeject/wbs"}
// module id = 15
// module chunks = 0